import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { RoundAndClinicModel } from '../models/RoundAndClinicModel';
@Injectable({
  providedIn: 'root'
})
export class RoundAndClinicService {

 constructor(private http: HttpClient, public urlsconfig: URLsConfig) {}
    public Getroundandclinic(patientcode: string) {
       let params = new HttpParams();
         params = params.append("patientcode",patientcode );
         const options = {
             params: params
         };
         return this.http.get<RoundAndClinicModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/roundandclinic/GetRoundAndClinic',options);
     }

         public Addroundandclinic(RoundAndClinic :RoundAndClinicModel) {
             return this.http.post<RoundAndClinicModel>(this.urlsconfig.WebAPIURL_Test + 'api/roundandclinic/Addroundandclinic', RoundAndClinic);
     }

     public DeleteRounds(patientcode : string , notetype : string, userid : string , date :string )
     {
      let params = new HttpParams();
      params = params.append("patientcode",patientcode);
      params = params.append("notetype",notetype);
      params = params.append("userid",userid);
      params = params.append("date",date);
      const options = {
        params : params
      };
               return this.http.get<RoundAndClinicModel>(this.urlsconfig.WebAPIURL_Test + 'api/roundandclinic/DeleteRoundAndClinic',options);
     }

}
